import './ServiceBlock.scss';

import { useState } from 'react';
import ReactModal from 'react-modal';
import classNames from 'classnames';

import useWindowDimensions from 'hooks/useWindowDimensions';
import EditServiceModal from 'pages/Profile/modals/EditServiceModal';
import { serviceDetails, toHoursAndMinutes } from 'util';

export default function ServiceBlock({
  service,
  className,
  actionsOnHover,
  isMyProvider,
}) {
  const [isOpen, openModal] = useState();
  const [isServiceModalOpen, openServiceModal] = useState(false);
  const { width } = useWindowDimensions();
  const isMobile = width <= 600;

  return (
    <div className={classNames('service-block pb-24', className)}>
      <div className="flex-row align-start justify-between mb-12">
        <div className="flex-column">
          <p className="bold service-block-name">{service.name}</p>
          <p className="f15 service-block-animal-type">
            {serviceDetails(service)}
          </p>
          {service.durationMinutes && (
            <p className="italic c-primary-purple f15 service-block-duration">{`Duration: ${toHoursAndMinutes(
              service.durationMinutes
            )}`}</p>
          )}
        </div>
        <p className="bold service-block-price">{service.price?.localized}</p>
      </div>
      <p className="service-block-text">{service.description}</p>
      {!isMobile && (
        <div className="flex-row align-center mt-5 actions">
          <span
            tabIndex={0}
            className={classNames(
              'c-primary-orange mr-15 pointer',
              actionsOnHover && 'actions-on-hover'
            )}
            role="button"
            onClick={() => openModal(true)}
          >
            View more
          </span>
          {isMyProvider && (
            <span
              tabIndex={0}
              className={classNames(
                'c-primary-orange pointer',
                actionsOnHover && 'actions-on-hover'
              )}
              role="button"
              onClick={() => openServiceModal(true)}
            >
              Edit
            </span>
          )}
        </div>
      )}
      <ReactModal
        ariaHideApp={false}
        isOpen={isOpen}
        onRequestClose={() => openModal(false)}
      >
        <div className="flex-row align-center justify-between mb-15">
          <div className="flex-column">
            <h2>{service.name}</h2>
            <p>{serviceDetails(service)}</p>
            {service.durationMinutes && (
              <p className="italic c-primary-purple">{`Duration: ${toHoursAndMinutes(
                service.durationMinutes
              )}`}</p>
            )}
          </div>
          <h2 className="bold service-block-price">
            {service.price?.localized || ''}
          </h2>
        </div>
        <p>{service.description}</p>
      </ReactModal>
      <EditServiceModal
        service={service}
        isOpen={isServiceModalOpen}
        openModal={openServiceModal}
      />
    </div>
  );
}
